import classNames from 'classnames';
import * as React from 'react';
import styles from 'src/components/assets/simple-table.module.scss';
import { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { asyncPersistAdminWork } from 'src/store/actions/adminWork-actions';
import { Dispatch } from 'redux';
import { DateTimePicker } from 'react-widgets';
import { StoreState } from '../../../../../../../../../store/reducers';
import { changeToZeroMoment, changeToZeroZoneDate } from 'src/helpers/timeHelpers';
import Loader from '../../../../../../../../../components/Loader';
import GeneralEnumService from '../../../../../../../../../enumerables/general-enum';
import moment from 'moment';
import { toast } from 'react-toastify';

export interface StateProps {
    inProgress: boolean;
}

export interface DispatchProps {
    updateData: (val: any) => Promise<any>;
}

export interface OwnProps {
    columns: { id: string; label: string; type?: string; cellStyle: string }[];
    row: any;
    key: string;
    action: (val: any) => void;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}
export interface State {
    id?: string | number;
    adminWorkDate: Date | undefined;
    startTime: any;
    endTime: any;

    description: string;
    providerId?: string;
    columnForm?: boolean;
    status: { label: string; value: number };
}

class FormColumn extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);

        const start = changeToZeroZoneDate(props.row.startTime);
        const end = changeToZeroZoneDate(props.row.endTime);

        this.state = {
            id: '',
            description: props.row.description ? props.row.description : '',
            status: { label: 'one', value: 1 },
            adminWorkDate: props.row.adminWorkDate ? changeToZeroZoneDate(props.row['adminWorkDate']) : undefined,
            startTime: props.row.startTime ? start : undefined,
            endTime: props.row.endTime ? end : undefined,
        };
    }

    handleChange = (event: ChangeEvent<HTMLInputElement>, name: string) => {
        this.setState({ ...this.state, [name]: event.target.value });
    };
    handleSubmit = async () => {
        const endTimeT = new Date(this.state.endTime);

        let endTime = endTimeT.getHours();
        if (!endTime || endTime < 6) {
            endTime = 24;
        }

        endTime = +endTime * 60 + endTimeT.getUTCMinutes();

        const startT = new Date(this.state.startTime);

        let start = startT.getHours();
        start = 60 * +start + startT.getUTCMinutes();

        if (endTime <= start) {
            toast.error('Incorrect time!');
            return null;
        }

        let status: any = this.state.status;
        if (this.state.status?.label) {
            status = status?.value;
        }

        await this.props.updateData({ ...this.state, status, id: this.props.row?.id });
        return this.props.action(false);
    };
    render() {
        const { setOpenDrop, status, id, getData } = this.props.row;

        const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('AdminWorkStatus') : {};
        const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
        const valueStatus: any = statusItems.find((it) => it.value === status);
        const valueStatusLabel = valueStatus ? valueStatus.label : '';
        const today = new Date();
        const columnChange: any = {
            id: (
                <input
                    type="hidden"
                    className={classNames('form-control', 'input-sm')}
                    onChange={(ev) => this.handleChange(ev, 'id')}
                    value={this.state['id']}
                />
            ),
            adminWorkDate: (
                <div style={{ minWidth: 150, maxWidth: 150 }}>
                    {+valueStatus?.value === +4 ? (
                        changeToZeroMoment(this.props.row?.adminWorkDate, 'MMM D, YYYY')
                    ) : (
                        <DateTimePicker
                            onChange={(date: any) => {
                                this.setState({ ...this.state, adminWorkDate: date });
                            }}
                            disabled={!id ? false : true}
                            value={this.state['adminWorkDate']}
                            time={false}
                            date={true}
                            dropUp
                            onToggle={(isOpen) => {
                                if (isOpen) {
                                    setOpenDrop(true);
                                } else {
                                    setOpenDrop(false);
                                }
                            }}
                            format={'MMM D, YYYY'}
                        />
                    )}
                </div>
            ),

            startTime: (
                <div style={{ minWidth: 130, maxWidth: 130 }}>
                    <DateTimePicker
                        onChange={(date: any, dateStr) => {
                            const dateTime = dateStr ? moment(dateStr, 'h:m A').toDate() : new Date();
                            this.setState({ ...this.state, startTime: dateTime });
                        }}
                        dropUp
                        value={this.state['startTime']}
                        time={true}
                        min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                        max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                        onToggle={(isOpen) => {
                            if (isOpen) {
                                setOpenDrop(true);
                            } else {
                                setOpenDrop(false);
                            }
                        }}
                        date={false}
                        step={15}
                        format={'LT'}
                    />
                </div>
            ),
            endTime: (
                <div style={{ minWidth: 130, maxWidth: 130 }}>
                    <DateTimePicker
                        onChange={(date: any, dateStr) => {
                            const dateTime = dateStr ? moment(dateStr, 'h:m A').toDate() : new Date();
                            this.setState({ ...this.state, endTime: dateTime });
                        }}
                        dropUp
                        value={this.state['endTime']}
                        time={true}
                        date={false}
                        min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                        max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                        onToggle={(isOpen) => {
                            if (isOpen) {
                                setOpenDrop(true);
                            } else {
                                setOpenDrop(false);
                            }
                        }}
                        step={15}
                        format={'LT'}
                    />
                </div>
            ),
            status: <div>{valueStatusLabel}</div>,

            action: (
                <div>
                    <button
                        className={classNames(styles.buttonColumn, 'mr-3')}
                        type={'button'}
                        onClick={() => this.handleSubmit()}
                    >
                        <FontAwesomeIcon style={{ color: 'green' }} icon={faCheckCircle} />
                    </button>
                    <button
                        className={classNames(styles.buttonColumn, 'mr-3')}
                        type={'button'}
                        onClick={() => this.props.action(false)}
                    >
                        <FontAwesomeIcon style={{ color: 'red' }} icon={faTimesCircle} />
                    </button>
                </div>
            ),
        };

        columnChange.description = (
            <div style={{ minWidth: 215 }}>
                <textarea
                    className={classNames('form-control', 'input-sm')}
                    onChange={(event) => {
                        this.setState({ ...this.state, description: event.target.value });
                    }}
                    maxLength={255}
                    value={this.state.description}
                />
            </div>
        );
        const isMobile = window.innerWidth <= 800;
        if (isMobile) {
            return (
                <div className={classNames(styles.relative)}>
                    {this.props.columns.map(
                        (column: { id: string; label: string; type?: string; cellStyle: string }, key) => (
                            <div
                                style={{ minHeight: 50, fontSize: 14 }}
                                className={
                                    'border-secondary text-center  d-flex justify-content-center align-items-center border border-bottom-1'
                                }
                                key={`td-${key}`}
                            >
                                {columnChange[column.id]}
                            </div>
                        ),
                    )}
                    <div className={classNames(styles.hide)}>{this.props.inProgress ? <Loader /> : ''}</div>
                </div>
            );
        } else {
            return (
                <tr className={classNames(styles.relative)}>
                    {this.props.columns.map(
                        (column: { id: string; label: string; type?: string; cellStyle: string }, key) => (
                            <td key={`td-${key}`} className={classNames(styles[column.cellStyle])}>
                                {columnChange[column.id]}
                            </td>
                        ),
                    )}
                    <td className={classNames(styles.hide)}>{this.props.inProgress ? <Loader /> : ''}</td>
                </tr>
            );
        }
    }
}
function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.seances.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        updateData: async (data: any) => {
            await asyncPersistAdminWork(
                {
                    ...data,
                    provider: ownProps.row.providerId,
                    month: ownProps.row.month,
                    columnForm: true,
                },
                dispatch,
            );
            ownProps.row.getData({
                page: 1,
                filters: {
                    'provider.id': ownProps.row.providerId,
                    'adminWorkDate[before]': ownProps.row.month.monthEnd,
                    'adminWorkDate[after]': ownProps.row.month.monthStart,
                    //  'order[seanceDate]': 'asc',
                },
                itemsPerPage: 9000,
            });
            return;
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(FormColumn);
